import { CommonModule } from '@angular/common';
import { Component, ChangeDetectionStrategy, Input } from '@angular/core';

import {
  PlaceholderDefaultDimension, PlaceholderDimension, PlaceholderType
} from '@design-system/components/atoms/placeholder/entities/placeholder.types';

@Component({
  selector: 'app-ds-placeholder',
  templateUrl: './placeholder.component.html',
  styleUrls: ['./placeholder.component.sass'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CommonModule]
})
export class PlaceholderDsComponent {

  @Input() type = PlaceholderType.Primary;
  @Input() width: PlaceholderDimension = PlaceholderDefaultDimension;
  @Input() height: PlaceholderDimension = PlaceholderDefaultDimension;

  public readonly placeholderType = PlaceholderType;
  public readonly defaultDimension = PlaceholderDefaultDimension;

  constructor() { }

  public useMeasurements(d: PlaceholderDimension): boolean {
    return this.type === PlaceholderType.Primary && !!d && !d.includes('%');
  }

}
